import { formatTimestampForDateTime } from "shared/utils/dates";

import DateRangeInput from "components/customInputs/DateRangeInput";

import {
  DateRangeFiltersState,
  FilterLabels,
} from "../casesTable/CaseAdminFilters.contracts";

type DateRangeFiltersProps = DateRangeFiltersState & {
  onChangeDateRange: Function;
};

const dateInputLabel = {
  receivedDate: "Date Received",
  collectedDate: "Date Collected",
  accessionCompleted: "Accessioned Date",
  finalizedAt: "Finalized Date",
};

export const mapDateRangeFilterToLabel = Object.entries(dateInputLabel).reduce(
  (acc, [key, value]) => ({
    ...acc,
    [`${key}Before`]: `${value} - Before`,
    [`${key}After`]: `${value} - After`,
  }),
  {} as FilterLabels<DateRangeFiltersState>
);

const DateRangeFilters = (props: DateRangeFiltersProps) => {
  return (
    <>
      <div className="AdminFilters--span">
        <DateRangeInput
          id="case_receivedDate"
          label={dateInputLabel.receivedDate}
          type="datetime-local"
          values={{
            from: {
              id: "receivedDateAfter",
              name: "received_date_after",
              value: props.receivedDateAfter
                ? formatTimestampForDateTime(props.receivedDateAfter as string)
                : "",
            },
            to: {
              id: "receivedDateBefore",
              name: "received_date_before",
              value: props.receivedDateBefore
                ? formatTimestampForDateTime(props.receivedDateBefore as string)
                : "",
            },
          }}
          onChangeDate={props.onChangeDateRange}
          isClearable
        />
      </div>
      <div className="AdminFilters--span">
        <DateRangeInput
          id="case_collectedDate"
          label={dateInputLabel.collectedDate}
          type="datetime-local"
          values={{
            from: {
              id: "collectedDateAfter",
              name: "collected_date_after",
              value: props.collectedDateAfter
                ? formatTimestampForDateTime(props.collectedDateAfter as string)
                : "",
            },
            to: {
              id: "collectedDateBefore",
              name: "collected_date_before",
              value: props.collectedDateBefore
                ? formatTimestampForDateTime(
                    props.collectedDateBefore as string
                  )
                : "",
            },
          }}
          onChangeDate={props.onChangeDateRange}
          isClearable
        />
      </div>
      <div className="AdminFilters--span">
        <DateRangeInput
          id="accessionCompleted"
          label={dateInputLabel.accessionCompleted}
          type="datetime-local"
          values={{
            from: {
              id: "accessionCompletedAfter",
              name: "accession_completed_after",
              value: props.accessionCompletedAfter
                ? formatTimestampForDateTime(
                    props.accessionCompletedAfter as string
                  )
                : "",
            },
            to: {
              id: "accessionCompletedBefore",
              name: "accession_completed_before",
              value: props.accessionCompletedBefore
                ? formatTimestampForDateTime(
                    props.accessionCompletedBefore as string
                  )
                : "",
            },
          }}
          onChangeDate={props.onChangeDateRange}
          isClearable
        />
      </div>
      <div className="AdminFilters--span">
        <DateRangeInput
          id="finalizedAt"
          label={dateInputLabel.finalizedAt}
          values={{
            from: {
              id: "finalizedAtAfter",
              name: "finalized_at_after",
              value: props.finalizedAtAfter,
            },
            to: {
              id: "finalizedAtBefore",
              name: "finalized_at_before",
              value: props.finalizedAtBefore,
            },
          }}
          onChangeDate={props.onChangeDateRange}
          isClearable
        />
      </div>
    </>
  );
};

export default DateRangeFilters;
